/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Overviewticketoutstanding2Inputs */

const en_overviewticketoutstanding2 = /** @type {(inputs: Overviewticketoutstanding2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} still to be paid out`)
};

const de_overviewticketoutstanding2 = /** @type {(inputs: Overviewticketoutstanding2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.amount} noch auszuzahlen`)
};

/**
* | output |
* | --- |
* | "{amount} still to be paid out" |
*
* @param {Overviewticketoutstanding2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewticketoutstanding2 = /** @type {((inputs: Overviewticketoutstanding2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewticketoutstanding2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewticketoutstanding2(inputs)
	return de_overviewticketoutstanding2(inputs)
});
export { overviewticketoutstanding2 as "overviewTicketOutstanding" }